import { render, staticRenderFns } from "./ApprovedDetail.vue?vue&type=template&id=6c6173fe&scoped=true"
import script from "./ApprovedDetail.vue?vue&type=script&lang=js"
export * from "./ApprovedDetail.vue?vue&type=script&lang=js"
import style0 from "./ApprovedDetail.vue?vue&type=style&index=0&id=6c6173fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6173fe",
  null
  
)

export default component.exports